import { CONTENT_FULFILLED, COUNTDOWN_TICK } from '../actions';
import dateFromIso8601 from '../helpers/dateFromIso8601';

const initialState = {
};

const calculateCountdownState = until => {
  const [/* milliseconds */, seconds, minutes, hours, days] = (
    [1000, 60, 60, 24, 1].reduce(({ columns, remainder }, factor) => {
      if (factor === 1) {
        // final iteration: the remainder goes into the last column
        return [...columns, remainder];
      }
      return {
        columns: [...columns, remainder % factor],
        remainder: Math.floor(remainder / factor),
      };
    }, {
      columns: [],
      remainder: Math.max(0, until - Date.now()),
    })
  );

  return {
    until,
    days,
    hours,
    minutes,
    seconds,
  };
};

const initializeCountdown = (time, ...ids) => {
  if (time) {
    const until = dateFromIso8601(time).getTime();
    return {
      [ids.join('@')]: calculateCountdownState(until),
    };
  }
  return undefined;
};

const initializeSliceItemCountdowns = ({ sliceId, items = [] }) => (
  items.reduce((nextCountdowns, { countdown_until_time: time }, i) => ({
    ...nextCountdowns,
    ...initializeCountdown(time, sliceId, i),
  }), {})
);

const initializeCountdowns = (prevState, content) => ({
  ...(content.body || []).reduce((nextCountdowns, sliceContent) => ({
    ...nextCountdowns,
    ...initializeCountdown(sliceContent.countdown_until_time, sliceContent.sliceId),
    ...initializeSliceItemCountdowns(sliceContent),
  }), prevState),
});

const updateCountdowns = prevState => Object.keys(prevState).reduce((nextState, key) => ({
  ...nextState,
  [key]: calculateCountdownState(prevState[key].until),
}), {});

const countdown = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_FULFILLED:
      return initializeCountdowns(state, action.payload);
    case COUNTDOWN_TICK:
      return updateCountdowns(state);
    default:
      return state;
  }
};

export default countdown;
